import { useEffect, useMemo, useState } from 'react';
import { calculateTimerValues } from '../helpers/calculateTimerValues';
const useCountdown = (startDate, targetDate) => {
    const [countdown, setCountdown] = useState({
        date: new Date(),
        timeLeft: targetDate.getTime() - startDate.getTime(),
    });
    const timerValues = useMemo(() => calculateTimerValues(countdown.timeLeft), [countdown]);
    useEffect(() => {
        if (countdown.timeLeft > 0) {
            const interval = setInterval(() => {
                setCountdown((previous) => {
                    const date = new Date();
                    return {
                        date: date,
                        timeLeft: previous.timeLeft - date.getTime() + previous.date.getTime(),
                    };
                });
            }, 1000);
            return () => clearInterval(interval);
        }
    }, [countdown]);
    return [countdown.timeLeft <= 0, timerValues];
};
export { useCountdown };
